// extracted by mini-css-extract-plugin
module.exports = {"container":"Footer_container__3ed9K","info":"Footer_info__3bE-X","card":"Footer_card__1KBwj"};